module.exports = __webpack_public_path__ + "static/008-slideshow-ef8decfeedeadcdacde5685e1e7b8ab8.jpg";